import { render } from "./PlansPage.vue?vue&type=template&id=2b5a43b4"
import script from "./PlansPage.vue?vue&type=script&lang=js"
export * from "./PlansPage.vue?vue&type=script&lang=js"

import "./PlansPage.vue?vue&type=style&index=0&id=2b5a43b4&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__